// extracted by mini-css-extract-plugin
export default {"rnet":"mAUT4xez","separator":"separator"};